export default "__VITE_ASSET__crsJaIio__"